import { createStore } from 'vuex';

import auth from './auth/index.js';
import main from './main/index.js';
// import org from './org/index.js'; // not needed — org features removed from Header
import notifications from './notifications/index.js';
// import follow from './follow/index.js'; // not needed — follow action removed from Header

// ── Modules unused in admin panel (commented out to reduce bundle & startup cost) ──
// import siwf from './siwf/index.js';
// import user from './user/index.js';
// import block from './block/index.js';
// import modals from './modal/index.js';
// import posts from './posts/index.js';
// import metrics from './metrics/index.js';
// import channels from './channels/index.js';
// import twoFactorAuth from './twoFactorAuth/index.js';

const store = createStore({
  modules: {
    auth,          // login, session restore (getMe), OTP flow
    main,          // setRouteLoading / getIsRouteLoading used by router
    // org,        // not needed — org features removed from Header
    notifications, // Header: unread notification badge
    // follow,     // not needed — follow action removed from Header
  },
});

export default store;
